import { MarketMaker } from './models';

const marketmaker: MarketMaker = {}

export default marketmaker